import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <div className="Footer">
      <p>
        Open-Sourced code by <a href="https://github.com/mcmfeat?tab=repositories"> MCM</a>
      </p>
    </div>
  );
}
